/**
 * JOCta — Final CTA block (dark, with phone + form trigger)
 */
import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { useSettings } from "@/lib/useSettings";
import useUniversePhone from "@/lib/jardins-ole/useUniversePhone";

export default function JOCta() {
  const { settings: s } = useSettings();
  const phone = useUniversePhone() || "04 42 55 71 47";
  return (
    <section className="jo-section" data-testid="jo-cta">
      <div className="jo-container">
        <div className="jo-cta">
          <div className="relative z-10">
            <div className="jo-section-eyebrow" style={{ color: "var(--jdo-gold-soft)" }}>— On en parle ?</div>
            <h2 className="jo-cta-title">Votre jardin n'attend<br />qu'une bonne idée.</h2>
            <p className="jo-cta-subtitle">
              Visite en jardinerie, devis gratuit chez vous ou conseils par téléphone — on commence comme vous voulez.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <Link to="/contact" className="jo-btn-primary jo-btn-gold" data-testid="jo-cta-quote">
                Demander un devis gratuit
                <ArrowRight className="w-4 h-4" />
              </Link>
              <a href={`tel:${phone.replace(/\s/g,'')}`} className="jo-btn-secondary" style={{ color: "var(--jdo-cream)", borderColor: "rgba(250,247,238,0.5)" }} data-testid="jo-cta-phone">
                <Phone className="w-4 h-4" />
                {phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
